// src/App.js
import React from 'react';
import AgenticDashboard from './components/AgenticDashboard';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { WebSocketProvider } from './components/WebSocketContext';
import {SessionProvider} from './components/SessionContext'

function App() {
  return (
    <SessionProvider>
      <div className="min-h-screen text-white" style={{ backgroundColor: '#000814' }}>
        <AgenticDashboard />
        <ToastContainer />
      </div>
    </SessionProvider>
  );
}

export default App;
